export const EbooksLogo = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="34" height="34" rx="3.5" stroke="#05050D" strokeOpacity="0.05" />
      <path
        d="M25.7333 10C23.0571 10.0109 21.0676 10.36 19.628 10.9634C18.5537 11.4134 18.1333 11.7539 18.1333 12.9074V25C19.7788 23.5938 21.239 23.2 27 23.2V10H25.7333ZM9.26667 10C11.9429 10.0109 13.9324 10.36 15.372 10.9634C16.4463 11.4134 16.8667 11.7539 16.8667 12.9074V25C15.2212 23.5938 13.761 23.2 8 23.2V10H9.26667Z"
        fill="#05050D"
      />
    </svg>
  );
};
